import { Component, OnInit } from '@angular/core';
import { PROFILEVIEW, PROFILEUPDATE } from 'src/app/config';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';

@Component({
    selector: 'app-change-profile',
    templateUrl: './change-profile.component.html',
    styleUrls: ['./change-profile.component.css'],
    
})
export class ChangeProfileComponent implements OnInit {
  loading:boolean;
  sign:boolean=true;
  data:any;
  alert:boolean;
  message:any;
  type:any;
  d:any;
  loader:boolean;
  page:boolean;
  imageUrl:any;
  baseUrls:any;
  constructor(private api:ApiService,private router:Router) {
    let mobile=this.api.getMobileNo();
    console.log(mobile);
    this.api.Post(PROFILEVIEW, {
      mobile:mobile
    }).then(data=>{
      this.page=true;
      this.loader=false;
      console.log(data);
      this.baseUrls = data['url'];
      this.data=data['user'];
      this.imageUrl = this.baseUrls + this.data['logo'];
      
      //this.router.navigate(['/registerOtp']);
    }).catch(d=>{
      if( d.status == 503){
        this.api.onFail('Your session is expired please login again','Login');
        this.api.setGoto();
        this.api.setlogin(0);
        this.api.logout();
        setTimeout(() => {
        this.router.navigate(['/login']);
        },1000);
      } else{
        console.log(d);
      }
});

  }
   
   update(value){
    this.loader=true;
    this.page=false;
    this.alert=false
    this.loading=true;
    this.sign=false;
    value.image = this.imageUrl;
    // console.log(value);
    this.api.Post(PROFILEUPDATE, value).then(data => {
      this.page=true;
      this.loader=false;
              console.log(data);
              this.alert=true;
              this.message="Successful Updated "
              this.type="success";
              this.loading=false;
              this.sign=true;
              // this.d=data['data'][0];
              // console.log(this.d); 
            
            this.api.setUserInfo(data['data']);
              //this.router.navigate(['/registerOtp']);
      }).catch(d=>{

        if( d.status == 503){
          this.api.onFail('Your session is expired please login again','Login');
          this.api.setGoto();
          this.api.setlogin(0);
          this.api.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{
          this.page=true;
          this.loader=false;
                console.log(d);
                this.type="danger";
                this.loading=false;
                this.sign=true;
                this.alert=true;
                this.message="Enter your all detail";
                console.log(d);
        }
      });
}
  ngOnInit(): void {
    this.loader=true;
    this.page=false;
}

onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        this.imageUrl = reader.result as string;
      };

      reader.readAsDataURL(file); // Convert to base64
    }
  }

}
